














import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreditCardModel } from '@/interfaces/registration/models/CreditCardModel';

@Component
export default class CreditCardEditor extends Vue {
  @Prop({ default: () => { return {}; } }) readonly value!: CreditCardModel;
  @Prop() readonly stripeKey!: string;

  public model: CreditCardModel = {
    number: this.value.number,
    expiration: this.value.expiration,
    securityCode: this.value.securityCode
  };

  public valueChanged (): void {
    this.$emit('input', this.model);
  }
}
